import * as core from '../../../../../../../core'
import * as changeImpactPhase from '../change-impact-phase'

export const RESOURCE = {
  payload: {
    description: 'Stewardship',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactPhase.RESOURCE.payload.partialId,
    }),
    id: 'Stewardship',
    name: 'Stewardship',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
